<span class="flex items-center" @fadeIn>
    <span class="mr-5 -mb-px font-sans text-sm font-bold leading-none uppercase text-simon-gray">Powered by</span>
    <img src="assets/images/simon-icapital-logo.svg" alt="" class="w-auto h-32">
</span>     